<template>
  <CModal :title="title" :color="color" size="lg" :show.sync="showModal">
    <CForm>

      <CRow>
        <CCol md="3">
          <CInput label="Ruta:" :lazy="false" :value.sync="$v.form.code.$model" />
        </CCol>
        <CCol md="9">
          <CInput label="Nombre:" :lazy="false" :value.sync="$v.form.name.$model" :isValid="checkIfValid('name')"
            placeholder="" autocomplete="given-name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow style="margin-top: 10px;">
        <CCol md="6">
          <CInput label="Correo Electrónico (Usuario):" :lazy="false" :value.sync="$v.form.email.$model"
            :isValid="checkIfValid('email')" placeholder="" autocomplete="given-email"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
        <CCol md="6">
          <CSelect label="Supervisor" :value.sync="$v.form.manager_id.$model" :options="managersWithEmpty" />
        </CCol>
      </CRow>
      <CRow style="margin-top: 10px;">
        <CCol md="4">
          <CSelect label="Cedis" :value.sync="$v.form.cedis_id.$model" :options="cedisOptions" />
        </CCol>
        <CCol md="4">
          <CInput label="Monedero:" :lazy="false" :value.sync="$v.form.wallet.$model" />
        </CCol>
        <CCol md="4">
          <CInput label="Stock:" :lazy="false" :value.sync="$v.form.stock.$model" />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="6">
          <CInput :isValid="checkIfValid('password')" :value.sync="$v.form.password.$model" label="Contraseña"
            type="password" placeholder="" autocomplete="new-password"
            invalidFeedback="Debe tener al menos 8 caracteres y teniendo al menos un número, una mayúscula y una minúscula." />
        </CCol>
        <CCol md="6">
          <CInput :isValid="checkIfValid('confirmPassword')" :value.sync="$v.form.confirmPassword.$model"
            label="Confirmar Contraseña" type="password" placeholder="" autocomplete="confirm-password"
            invalidFeedback="Las contraseñas no coinciden." />
        </CCol>
      </CRow>
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"
import ws from '../../services/suppliers';
import managers_ws from '../../services/managers';
import cedis_ws from '../../services/cedis';
import store from '../../store'
import { homologateCode, normalizeNameToUppercase } from '../../utils/textNormalizers'

export default {
  name: 'SupplierModal',
  props: {
    managers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      title: "Nuevo Vendedor",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: '', class: 'actions' }
      ],
      link: '',
      item: false,
      managersWithEmpty: [],
      cedisOptions: [],
      form: {
        id: 0,
        code: '',
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        manager_id: '',
        cedis_id: '',
        wallet: '',
        stock: ''
      },
    }
  },
  computed: {
    formString() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$invalid },
    isDirty() { return this.$v.form.$anyDirty },
  },


  mounted: async function () {
    let res = await cedis_ws.get();

    if (res.type == "success") {
      this.cedisOptions = await this.$parseSelectOptionsOrdered(res.data, "id", "name", [{ value: '', label: 'Sin Cedis asignado' }]);
    }
  },
  methods: {
    storeModal() {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Vendedor';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
        id: 0,
        code: '',
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        manager_id: '',
        cedis_id: '',
        wallet: '',
        stock: ''
      }
    },
    updateModal(item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Vendedor';
      this.isEdit = true;
      this.submitted = false;

      this.item = item;

      if (item.user && item.user.api_token) {
        this.link = "https://app.kpibonus.com/#/" + item.user.api_token + "/login-link";
      }
      else {
        this.link = false;
      }

      this.form = {
        id: item.id,
        code: item.code,
        name: item.name,
        email: item.user && item.user.email ? item.user.email : '',
        password: '**********',
        confirmPassword: '**********',
        manager_id: item.manager_id > 0 ? item.manager_id : "",
        cedis_id: item.cedis_id > 0 ? item.cedis_id : "",
        wallet: item.wallet != "" ? item.wallet : "",
        stock: item.stock != "" ? item.stock : ""
      };
    },
    store() {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        if (this.form.id > 0) {
          this.$emit("update", this.form);
        }
        else {
          this.$emit("store", this.form);
        }

        this.closeModal();
      }
    },
    async generate() {
      let response = await ws.generateLink(this.form);

      if (response.type == "success") {
        this.link = response.data.link;
        this.form.email = response.data.user.email;
        this.form.password = '12345678';

        this.$emit("update", this.form);
      }
    },
    closeModal() {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm() {
      return {
        id: 0,
        code: '',
        name: '',
        email: '',
        password: '**********',
        confirmPassword: '**********',
        manager_id: '',
        cedis_id: '',
        wallet: '',
        stock: ''
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }

      return !(field.$invalid || field.$model === '')
    },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      code: {
      },
      email: {
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs("password")
      },
      manager_id: {
      },
      cedis_id: {
      },
      wallet: {
      },
      stock: {
      }
    }
  },
  watch: {
    'form.code': {
      immediate: false,
      handler(value) {
        const normalized = homologateCode(value)
        if (normalized !== value) {
          this.form.code = normalized
        }
      }
    },
    'form.name': {
      immediate: false,
      handler(value) {
        const normalized = normalizeNameToUppercase(value)
        if (normalized !== value) {
          this.form.name = normalized
        }
      }
    },
    managers: {
      immediate: true,
      async handler(val) {
        this.managersWithEmpty = await this.$parseSelectOptionsOrdered(
          val || [],
          "id",
          "display_name",
          [{ value: '', label: 'Sin supervisor asignado' }]
        );
      }
    }
  }

}
</script>